import { Link } from 'react-router-dom'

import { NAVIGATION } from 'constant/config'

import { useSettingsStore } from 'stores/settingsStore'
import { useMediaQuery } from 'hooks/useMediaQuery'

import style from './index.module.scss'

const Logo = () => {
  const { settings } = useSettingsStore()
  const isMobile = useMediaQuery('(max-width: 1279px)')

  return (
    <Link
      className={style.block}
      to={NAVIGATION.my_casino.url}
    >
      <img
        className={style.image}
        src={isMobile ? settings.assets.logo_mobile : settings.assets.logo_desktop}
        alt={settings.name}
        loading="eager"
        fetchPriority="high"
        decoding="async"
        width={102}
        height={35}
      />
    </Link>
  )
}

export default Logo
